module.exports = __webpack_public_path__ + "img/people_img_3_1.b290a0ee.png";